module.exports = __webpack_public_path__ + "img/downloading.db79e3ed.svg";